import { isNil } from "lodash"

const getMultipaymentPrice = (price, multipaymentData) => {
  if (!price || !multipaymentData) return null

  const multipaymentValid = multipaymentData.find(
    (p) =>
      (isNil(p.min) || price >= p.min) &&
      (isNil(p.max) || price < p.max)
  )

  return multipaymentValid
    ? {
        count: multipaymentValid.count,
        installment: price / multipaymentValid.count,
        applicationFee: multipaymentValid.applicationFee,
      }
    : null
}

export { getMultipaymentPrice }
